import { SectionHeader, TopBar } from "~/common/components";
import { MultiSelectGroup } from "~/common/components/ui/multiSelectGroup";
import { useHandlePatientSearchFilters } from "~/providers/hooks/useHandlePatientSearchFilters";
import { useUiStore } from "~/providers/stores";
import { FilterResultSummary } from "../FilterResultSummary";
import SearchBar from "../SearchBar";

interface PatientSearchFiltersProps {
  isLoading?: boolean;
  hasNoPatients?: boolean;
  totalPatients?: number;
  filteredPatientsCount?: number;
}

export const PatientSearchFilters = ({
  isLoading,
  hasNoPatients,
  totalPatients = 0,
  filteredPatientsCount,
}: PatientSearchFiltersProps) => {
  const { setSideBarOpen } = useUiStore();

  const {
    handleNameFilterChange,
    handlePatientSearchFilters,
    multiSelectGroupValues,
    nameFilter,
    patientSearchFiltersOptions,
    hasAllFiltersApplied,
  } = useHandlePatientSearchFilters();

  const disableSearchBarFilter =
    hasNoPatients && hasAllFiltersApplied && !nameFilter;

  return (
    <div className="grid items-start justify-between gap-4 md:flex">
      <div className="flex items-center gap-4">
        <TopBar handleOpenSideBar={() => setSideBarOpen(true)} />
        <SectionHeader className="flex flex-col text-xl font-semibold xl:text-3xl">
          Patient search
          <FilterResultSummary
            filteredPatientsCount={filteredPatientsCount}
            totalPatients={totalPatients}
          />
        </SectionHeader>
      </div>

      <div className="flex flex-wrap gap-4 lg:flex-nowrap">
        <SearchBar
          className="w-full"
          disabled={disableSearchBarFilter}
          isLoading={isLoading}
          value={nameFilter}
          placeholder="Search by patient name"
          setValue={handleNameFilterChange}
        />
        <div className="flex w-full items-center justify-start md:w-fit md:justify-end">
          <MultiSelectGroup
            onChange={handlePatientSearchFilters}
            value={multiSelectGroupValues}
            placeholder="Filter by"
            name="patientSearch"
            options={patientSearchFiltersOptions}
          />
        </div>
      </div>
    </div>
  );
};
